import React, { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip } from 'chart.js'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
Chart.register(ArcElement, Tooltip);

interface IDashboardChartCard {
    pickupChartData: {
        labels: string[];
        datasets: {
            data: number[];
            backgroundColor: string[];
        }[];
    };
    pickupData: {
        title: string;
        value: number;
        darkBgColor: string;
        lightBgColor: string;
    }[];
    deliveryChartData: {
        labels: string[];
        datasets: {
            data: number[];
            backgroundColor: string[];
        }[];
    };
    deliveryData: {
        title: string;
        value: number;
        darkBgColor: string;
        lightBgColor: string;
    }[];
}

const DashboardChartCard = ({ pickupChartData, pickupData, deliveryChartData, deliveryData }: IDashboardChartCard) => {
    const [pickupChart, setPickupChart] = useState(null);
    const [pickup, setPickup] = useState(null);
    const [deliveryChart, setDeliveryChart] = useState(null);
    const [delivery, setDelivery] = useState(null);

    useEffect(() => {
        setPickupChart(pickupChartData);
        setPickup(pickupData);
        setDeliveryChart(deliveryChartData);
        setDelivery(deliveryData);
    }, [pickupChartData, pickupData, deliveryChartData, deliveryData]);

    return (
        <div className='w-full my-10 gap-4 flex flex-wrap justify-between'>
            <div className='bg-white w-full lg:w-[48%] 2xl:w-[32%] rounded-lg shadow-lg p-4 flex flex-col lg:flex-row gap-5 justify-between items-center'>
                <div className='w-[90%] lg:w-[40%] flex justify-center items-center relative'>
                    {pickupChart && <Doughnut options={{ responsive: true }} data={pickupChart} className='z-10' />}
                    <div className='h-full w-full absolute top-0 left-0 flex justify-center items-center z-0'>
                        <img alt='dashboard 1' src='https://res.cloudinary.com/di23omfvx/image/upload/v1692442026/chartLoading_f0gh1w.gif' className='rounded-full z-0' />
                    </div>
                </div>
                <div className='flex flex-col justify-between gap-2'>
                    {pickup?.map((pickup, index) => {
                        return (
                            <div key={index} className='p-2 rounded' style={{ backgroundColor: pickup?.lightBgColor }}>
                                <div className='flex gap-3 items-center w-full text-text_1 font-bold'><span className='w-4 h-4 rounded-full' style={{ backgroundColor: pickup?.darkBgColor }} />{pickup?.title}</div>
                                <div className='font-bold ml-8' style={{ color: pickup?.darkBgColor }}>{pickup?.value}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className='bg-white w-full lg:w-[48%] 2xl:w-[32%] rounded-lg shadow-lg p-4 flex flex-col lg:flex-row gap-5 justify-between items-center'>
                <div className='w-[90%] lg:w-[40%] flex justify-center items-center relative'>
                    {deliveryChart && <Doughnut options={{ responsive: true }} data={deliveryChart} className='z-10' />}
                    <div className='h-full w-full absolute top-0 left-0 flex justify-center items-center z-0'>
                        <img alt='dashboard 2' src='https://res.cloudinary.com/di23omfvx/image/upload/v1692442026/chartLoading_f0gh1w.gif' className='rounded-full z-0' />
                    </div>
                </div>
                <div className='flex flex-col justify-between gap-2'>
                    {delivery?.map((delivery, index) => {
                        return (
                            <div key={index} className='p-2 rounded' style={{ backgroundColor: delivery?.lightBgColor }}>
                                <div className='flex gap-3 items-center w-full text-text_1 font-bold'><span className='w-4 h-4 rounded-full' style={{ backgroundColor: delivery?.darkBgColor }} />{delivery?.title}</div>
                                <div className='font-bold ml-8' style={{ color: delivery?.darkBgColor }}>{delivery?.value}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className='bg-white w-full lg:w-[100%] 2xl:w-[32%] rounded-lg shadow-lg p-4 flex flex-wrap sm:flex-row md:flex-wrap justify-between gap-4'>
                <Calendar className="!border-none !w-full" />
            </div>
        </div>
    )
}

export default DashboardChartCard